import { merge } from "lodash";

const activeEditor = (state = 0, action) => {
  let newState = 0;
  switch (action.type) {
    case 'UPDATE_ACTIVE_EDITOR':
      let {
        activeEditorComponentNumber
      } = action;

      return activeEditorComponentNumber;
    case 'REFRESH_ACTIVE_EDITOR':
      return newState;
    default:
      return state;
  }
};

export default activeEditor;